import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import './whatsApp.css';

const WhatsApp = () => {

  const phoneNumber = 7711030518;
  const message = "Hi, i need information";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsApp;
